import { Col, Row, Typography } from "antd";
import { PropsWithChildren } from "react";
import styles from "./CommonDrawer.module.scss";
import localStyles from "./FieldWrapper.module.scss";

type InputLabelProps = PropsWithChildren<{
  label?: string;
  width?: number;
  required?: boolean;
}>;

export const FieldWrapper = ({
  label,
  width,
  children,
  required,
}: InputLabelProps) => {
  return (
    <Col span={!width || width > 20 ? 20 : width} className={styles.field}>
      <Row>
        {label && (
          <Col span={24}>
            <Typography.Text>{label}</Typography.Text>
            {required && (
              <Typography.Text className={localStyles.requiredMark}>
                *
              </Typography.Text>
            )}
          </Col>
        )}
        <Col span={24}>{children}</Col>
      </Row>
    </Col>
  );
};
